import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import useIsSsr from '../../../hooks/useIsSsr';

var UpdatePaymentBanner = function UpdatePaymentBanner(_ref) {
  var intl = _ref.intl;

  var _a;

  var isSSR = useIsSsr();
  if (isSSR) return null;
  if (((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) === '/user/account/my-plan') return null;
  return React.createElement(Box, {
    sx: {
      backgroundColor: '#C12A2A',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: {
        xs: '15px',
        md: '15px 30px',
        lg: '5px 48px'
      }
    }
  }, React.createElement(Box, {
    flex: 1
  }, React.createElement(Typography, {
    variant: 'subtitle2',
    style: {
      color: 'white'
    }
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'payment_error',
    defaultMessage: 'We were unable to charge this month’s subscription to your card. It may have reached it’s limit.'
  }))), React.createElement(Button, {
    sx: {
      color: 'white',
      borderColor: 'white',
      ':hover': {
        color: 'pink',
        borderColor: 'pink'
      },
      flexShrink: 1
    },
    href: '/user/account/my-plan',
    variant: 'outlined'
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'resolve_payment_plan',
    defaultMessage: 'Resolve my plan'
  })));
};

export default UpdatePaymentBanner;